<template>
  <div v-if="!isStayBundle" class="buybox__atc">
    <button class="btn btn--primary" @click="atc()" :disabled="!selectedVariant.available || selectedVariant.sold_out" v-html="buttonText">
    </button>
  </div>
  <div v-else class="buybox__atc buybox__bundle__atc" :data-bundle-product-id="selectedVariant.id" :data-bundle-selling-plan="selectedSellingPlan.id">
    <button class="btn btn--primary bundle-submit-button" disabled @click="atcBundle($event)" :disabled="!selectedVariant.available || selectedVariant.sold_out">

      <span class="bundle-submit-button-atc-text hide">
        <span>Add to Bag</span>
        <span class="button-otp-text" :class="{ hide: isSubscription }"></span>
        <span class="button-sub-text" :class="{ hide: !isSubscription }"></span>
      </span>
      <span class="bundle-submit-button-add-more-text" data-bundle-submit-button-add-more-text>
        Select
        <span class="bundle-submit-button-add-more-quantity" data-bundle-submit-button-add-more-quantity>{{ !isSubscription ?  product.otpBundleMin : product.subBundleMin}}</span>
        or more products
      </span>

    </button>
  </div>
</template>

<script setup>
  import { computed, toRefs, ref } from 'vue';

  const props = defineProps({
    product: {
      type: Object,
      default: () => ({})
    },

    isMultiPack: {
      type: Boolean,
      default: false, 
    },

    selectedVariant: {
      type: Object,
      default: null,
    },

    selectedSellingPlan: {
      type: Object,
      default: null,
    },

    isSubscription: {
      type: Boolean,
      default: false, 
    },

    isStayBundle: {
      type: Boolean,
      default: false, 
    },

    isOneFlavor: {
      type: Boolean,
      default: false, 
    }
  })

  const { product, isMultiPack, selectedVariant, selectedSellingPlan, isSubscription, isStayBundle } = toRefs(props);
  const emit = defineEmits(['track-event','toggle-option-drawer']);

  // Compute the total price of bundle variants based on data-price and input values
  const getBundleTotalPrice = computed(() => {
    if (!isStayBundle.value) return 0;

    // Find the bundle product list
    const contentBlock = document.querySelector('.buybox__content');
    const bundleBlock = contentBlock ? contentBlock.querySelector('.buybox__bundle') : null;
    const bundleProductList = bundleBlock ? bundleBlock.querySelector('.bundle-product-set-list') : null;
    const bundleProductListInputs = bundleProductList ? bundleProductList.querySelectorAll('.bundle-product-select-quantity-input') : [];

    let totalPrice = 0;
    bundleProductListInputs.forEach((input) => {
      const price = parseFloat(input.dataset.price) || 0;
      const quantity = parseInt(input.value) || 0;
      totalPrice += price * quantity;
    });

    return totalPrice;
  });

  // Compute the button text based on isStayBundle and variant availability
  const buttonText = computed(() => {
    if (!selectedVariant.value?.available || selectedVariant.value?.sold_out) {
      return 'Sold Out';
    }

    if (isStayBundle.value) {
      // Calculate total price for bundle by adding bundle total price to selected variant price
      const totalPrice = getSelectedVariantPrice.value + getBundleTotalPrice.value;
      return `<span>Add to Bag</span><span data-bundle-total>${totalPrice}</span>`;
    }

    // Default case: only selected variant price
    return `<span>Add to Bag</span><span>${getSelectedVariantPrice.value}</span>`;
  });

  const getSelectedVariantPrice = computed(() => {
    const item = selectedVariant.value;

    if (window.shopLocation !== 'GB' && isMultiPack.value) {
      return window.formattedPrice(item.price / 100);
    } else {
      if(isSubscription.value) {
        const sellingPlan = item.selling_plans.find(plan => plan.selling_plan.id === selectedSellingPlan.value.id);
        if (sellingPlan) {
          return window.formattedPrice((sellingPlan.per_delivery_price / 100).toFixed(2));
        }
      }

      return window.formattedPrice((item.price / 100).toFixed(2));
    }
  })

  const cartQuantity = ref(1);

  /*-- Test [template: test-buy-box] - start --*/
  function incrementQuantity() {
    cartQuantity.value++;
  }

  function decrementQuantity() {
    cartQuantity.value--;
  }
  /*-- Test [template: test-buy-box] - end --*/

  const atc = async() => {
    window.openCart();
    emit('toggle-option-drawer');
    await window.Additem({
      id: selectedVariant.value.id,
      quantity: cartQuantity.value ? cartQuantity.value : 1,
      ...(isSubscription.value) && {selling_plan: selectedSellingPlan.value.id}
    })
    emit('track-event',isSubscription.value ? 'Added Subscription to Cart' : 'Added One-Time to Cart')
  }

  // Add to cart function for Stay bundles
  const atcBundle = async(event) => {
    const bundleID = await getGuid();
    const contentBlock = event.target.closest('.buybox__content');
    const bundleBlock = contentBlock ? contentBlock.querySelector('.buybox__bundle') : null;

    const bundleProductID = selectedVariant.value.id;
    const bundleSellingPlan = isSubscription.value ? selectedSellingPlan.value.id : false;

    const interval = (bundleSellingPlan == '' ? 'otp' : 'sub');
    const bundleMin = (interval == 'otp' ? product.value.otpBundleMin : product.value.subBundleMin);
    const bundleMax = (interval == 'otp' ? product.value.otpBundleMax : product.value.subBundleMax);
    const bundleProductList = bundleBlock.querySelector('.bundle-product-set-list');
    const bundleProductListInputs = bundleProductList.querySelectorAll('.bundle-product-select-quantity-input');

    let bundleCart = [];
    let bundleProductQuantity = 0;
    {
        let cartItem = {
            id: bundleProductID,
            quantity: 1,
            properties: {
              "bundle_id": bundleID,
              "bundle_parent": true,
            },
        };
        if (interval == 'sub') {
            cartItem["selling_plan"] = bundleSellingPlan;
        }
        bundleCart.push(cartItem);
    }

    bundleProductListInputs.forEach(function(bundleProductInput){
        bundleProductQuantity = bundleProductQuantity + parseInt(bundleProductInput.value);
        if(parseInt(bundleProductInput.value) > 0) {
            let cartItem = {
                id: bundleProductInput.dataset.product,
                quantity: parseInt(bundleProductInput.value),
                properties: {
                    "bundle_id": bundleID,
                },
            };
            if (interval == 'sub') {
                cartItem["selling_plan"] = bundleSellingPlan;
            }
            bundleCart.push(cartItem);
        }
    });

    if( bundleProductQuantity > bundleMax || bundleProductQuantity < bundleMin ) {
        //quantity is not within bundle size
        return false;
    } else {
      window.openCart();
      emit('toggle-option-drawer');
      await window.Additem(bundleCart);
    }
  }

  // Generate unique IDs for the items in the Stay bundle
  const getGuid = async() => {
    let d = new Date().getTime();
    let d2 =  (performance && performance.now && (performance.now() * 1000)) || 0;
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
        let r = Math.random() * 16;
        if (d > 0) {
            r = (d + r) % 16 | 0;
            d = Math.floor(d / 16);
        } else {
            r = (d2 + r) % 16 | 0;
            d2 = Math.floor(d2 / 16);
        }
        return (c == 'x' ? r: (r & 0x7 | 0x8)).toString(16);
    });
}
</script>